import Dexie, {type Table} from "dexie";
import type {LibraryEntry, StudySession} from "@/shared/types";

export interface LocalLibraryEntry extends LibraryEntry {
  uri: string;
  cid: string;
  // Metadata for sync
  synced: boolean;
  isDeleted: 0 | 1;
}

export interface LocalStudySession extends StudySession {
  uri?: string;
  cid?: string;
  synced: boolean;
}

export class AtarashiiDatabase extends Dexie {
  libraryEntries!: Table<LocalLibraryEntry, string>;
  studySessions!: Table<LocalStudySession, string>;

  constructor() {
    super("AtarashiiDB");
    this.version(1).stores({
      libraryEntries: "uri, grouping, type, languageCode, createdAt, synced, isDeleted",
      studySessions: "++id, startedAt, activityType, synced",
    });
  }
}

export const db = new AtarashiiDatabase();
